import apiRequest from "./apiRequest";

export async function user(data) {
  return await apiRequest("user", data);
}

export async function trip(data) {
  return await apiRequest("trip", data);
}